module.exports = __webpack_public_path__ + "media/introduction_1.2ee341e5.mp4";